import manifest from '@/assets/image/worldcup2026/manifest.json'

const flagContext = require.context('@/assets/image/worldcup2026/team-flags', false, /\.png$/)
const localFlagMap = {}
const codeByName = {}
const preloadImages = []

;(manifest.categories['team-flags'] || []).forEach(item => {
  const code = String(item.team_code || '').toUpperCase()
  if (!code) return
  localFlagMap[code] = flagContext('./' + item.file)
  codeByName[normalizeName(item.team_name_zh)] = code
  codeByName[normalizeName(item.team_name_en)] = code
})

Object.assign(codeByName, {
  usa: 'D13',
  美国: 'D13',
  荷兰: 'F21',
  尼德兰: 'F21',
  英格兰: 'L45',
  英国: 'L45'
})

function normalizeName (value) {
  return String(value || '').replace(/\s+/g, '').toLowerCase()
}

function codeFromUrl (url) {
  if (!url) return ''
  const match = String(url).match(/worldcup2026\/([A-Z]\d+)\.png/i)
  return match ? match[1].toUpperCase() : ''
}

export function resolveTeamLogo (url, name) {
  const code = codeFromUrl(url) || codeByName[normalizeName(name)]
  if (code && localFlagMap[code]) {
    return localFlagMap[code]
  }
  return ''
}

export function teamLogosFromMatches (matches, round = 1) {
  const seen = {}
  const result = []
  ;(matches || []).forEach(match => {
    if (Number(match && match.round) !== Number(round)) return
    ;[
      [match.team_a_flag, match.team_a],
      [match.team_b_flag, match.team_b]
    ].forEach(([url, name]) => {
      const src = resolveTeamLogo(url, name)
      if (!src || seen[src]) return
      seen[src] = true
      result.push(src)
    })
  })
  return result
}

export function preloadTeamLogos (sources = []) {
  return sources.filter(Boolean).map(src => {
    const image = new Image()
    image.decoding = 'sync'
    image.src = src
    preloadImages.push(image)
    return image
  })
}

export function placeholderText (name) {
  if (!name) return ''
  if (name.indexOf('第') === 0) return '第'
  return String(name).slice(0, 1).toUpperCase()
}
